import api from "../../api/cofocusAPI";
import InternalUtilities from "./InternalUtilities";
import store from "../../store";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

const InternalAPI = {
  async logEvent(event, page_name) {
    if (!event || !page_name) {
      throw new Error("Required data not provided for request.");
    }

    const data = {
      event, 
      referrer_param: InternalUtilities.getTTCLID(),
      user_agent: navigator.userAgent,
      page_url: window.location.href,
      page_name,
    };
    if (!data.user_agent || !data.page_url) {
      return;
    }
    /* if (!data.referrer_param) {
      return;
    } */
    if (AuthStore && AuthStore.user && AuthStore.user._id && AuthStore.user.email) {
      data.UID = AuthStore.user._id;
      data.email = AuthStore.user.email;
    }
    return await api.getResponseData({
      url: `api/internal/event`,
      method: "post",
      data,
      withCredentials: true,
    });
  },
};

export default InternalAPI;
